import React from "react";

import ColorItem from "./components/color-item";

const ColorPickerDisplay = (props) => {
    const selectedItems = props.value.map((hex, i) => {
        return <ColorItem key={`selected_${i}of${props.value.length}`} hex={hex} />;
    });

    return (
        <div className="color-picker">
            <div className="selected-items">{selectedItems}</div>
        </div>
    );
};

export default ColorPickerDisplay;
